// Client for the v3 endpoints (docs/v3/API-v3.md). Project routes live under
// /api/p/:projectId; the org comes from the session, never from the request.
//   const p = projectApi(projectId);  p.get<Paged<Row>>("/activities")
//   useProjectApi() does the same inside a project route.
import { api, queryString } from "./client";
import { useProject } from "./project";

export type Query = Record<string, string | number | undefined | null>;

export function projectApi(projectId: string) {
  const base = `/api/p/${encodeURIComponent(projectId)}`;
  return {
    base,
    url: (path: string, q: Query = {}) => `${base}${path}${queryString(q)}`,
    get: <T>(path: string, q: Query = {}) => api.get<T>(`${base}${path}${queryString(q)}`),
    post: <T>(path: string, body: unknown = {}) => api.post<T>(`${base}${path}`, body),
    put: <T>(path: string, body: unknown) => api.put<T>(`${base}${path}`, body),
    patch: <T>(path: string, body: unknown) => api.patch<T>(`${base}${path}`, body),
    delete: <T = void>(path: string) => api.delete<T>(`${base}${path}`),
    download: (path: string, method: "GET" | "POST" = "GET") => api.download(`${base}${path}`, method),
  };
}

export function useProjectApi() {
  return projectApi(useProject().projectId);
}

/** Global v3 endpoints (/api/...): same shape as projectApi. */
export const apiV3 = {
  get: <T>(path: string, q: Query = {}) => api.get<T>(`/api${path}${queryString(q)}`),
  post: <T>(path: string, body: unknown = {}) => api.post<T>(`/api${path}`, body),
  put: <T>(path: string, body: unknown) => api.put<T>(`/api${path}`, body),
  patch: <T>(path: string, body: unknown) => api.patch<T>(`/api${path}`, body),
  delete: <T = void>(path: string) => api.delete<T>(`/api${path}`),
};
